<template>
  <div  :class="`col-span-6 ${ this.toggleSize ? 'h-56 min-h-full':''}`" >
    <label for="field.label" class="block text-sm font-medium leading-5 text-gray-700">
      {{field.label}}
    </label>
    <v-date-picker class="inline-block h-full" @change="changeValue()" v-model='dateValue' locale="es" ref="datePickerRef">
      <template v-slot="{ inputValue, togglePopover }">
        <div class="flex items-center">
          <button
            class="p-2 bg-gray-100 border border--200 hover:bg--200 text-gray-600 rounded-l focus:bg-gray-500 focus:text-white focus:border-gray-500 focus:outline-none"
            v-on:click.prevent="togglePopover({ placement: 'auto-start' })"
            >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              class="w-4 h-4 fill-current"
              >
              <path
                d="M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z"
                ></path>
            </svg>
          </button>
          <input
            :value="inputValue"
            class="bg-white text-gray-700 w-full py-1 px-2 appearance-none border rounded-r focus:outline-none focus:border-gray-500"
            disabled
            />
        </div>
      </template>
    </v-date-picker>
  </div>
</template>
<script>
export default {
  name: 'date-picker-field',
  data() {
    return {
      toggleSize: false,
      dateValue: ''
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.$watch(
        () => {
            return this.$refs.datePickerRef.$refs.popover.isVisible
        },
      (isVisible) => {
        this.toggleSize = isVisible
      }
    )
  },
  watch: {
    dateValue: function(newValue) {
      console.log('changeValue', newValue.getTime())
      this.$parent.updateValue(this.field.key, newValue.getTime())
    }
  }
}
</script>
